import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemInfo.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';
//hook
import usePartnerHook from 'src/webapp/hooks/partner/partner.hook';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//comp
import ImgArea from 'src/webapp/views/component/ImgArea';//브랜드로고이미지
import useComnHook from 'src/webapp/hooks/comn/comn.hook';

export default function Info(props) {
    const { itemInfo } = props;
    const location = useLocation();
    const params = useParams();
    //hook
    const { setOnMessageHandler } = useComnHook();
    const { vehiclePriceGroupListAPI, priceGroupList } = usePartnerHook();
    const { axiosPostHandler } = useAxiosHook();
    //항목카테고리필터
    const dataFilter = (i, type) => {
        switch (i) {
            case 0: return type === 0 ? '제품명' : itemInfo?.ITEM_NAME ?? null;
            case 1: return type === 0 ? '설명' : vehicleGroupData?.DESCRIPTION?.length > 0 ? vehicleGroupData?.DESCRIPTION : null;
            case 2: return type === 0 ? '단가' : vehicleGroupData?.PRICE > 0 ? vehicleGroupData?.PRICE + " 원" : null;
            case 3: return type === 0 ? '기술료' : vehicleGroupData?.ROYALTY > 0 ? vehicleGroupData?.ROYALTY + " 원" : null;
            case 4: return type === 0 ? '작업시간' : vehicleGroupData?.DURATION_TIME > 0 ? (vehicleGroupData?.DURATION_TIME * 30 + '분') : null;
            case 5: return type === 0 ? '타이어 구분' : (vehicleGroupData?.TIRE_FR > 0 && vehicleGroupData?.TIRE_FR === 1) ? "앞" : vehicleGroupData?.TIRE_FR === 2 ? "뒤" : null;
            case 6: return type === 0 ? '오일명' : vehicleGroupData?.OIL_NAME?.length > 0 ? vehicleGroupData?.OIL_NAME : null;
            case 7: return type === 0 ? '오일수' : vehicleGroupData?.OIL_QUOTA > 0 ? (vehicleGroupData?.OIL_UNIT === 1 ? Math.round(vehicleGroupData?.OIL_QUOTA) + '개' : Math.round(vehicleGroupData?.OIL_QUOTA * 100) + 'ml') : null;
            case 8: return type === 0 ? '오일필터가격' : (vehicleGroupData?.OIL_PRICE > 0 && vehicleGroupData?.OIL_PRICE > -1) ? (vehicleGroupData?.OIL_PRICE + '원') : null;
            case 9: return type === 0 ? '총 가격' : vehicleGroupData?.TOT_PRICE > 0 ? vehicleGroupData?.TOT_PRICE + " 원" : null;
        }
    }
    useEffect(() => { vehiclePriceGroupListAPI(); partnerVehicleListAPI(); }, [])//상품상세묶음 리스트호출
    const [vehicleGroupData, setVehicleGroupData] = useState(null);
    const [vehicleList, setVehicleList] = useState({ list: [], option: [] });
    const [modelList, setModelList] = useState([]);
    const vehiclePriceListAPI = async (item) => {
        const DATA = { ITEM_CD: params.item, SEQ_NO: item.SEQ_NO };
        const result = await axiosPostHandler(`partnerItemInfoListForPartner.do`, DATA);
        if (!result) { return; }
        if (result.message == "SUCCESS") {
            //result값 내 VEHICLE_CD 배열
            const resultVehicle = result.data.map(item => item.VEHICLE_CD);
            // 위 저장한 VEHICLE_CD 배열에 포함되는 모델 객체데이터
            const filterVehicle = vehicleList.list.filter((item) => resultVehicle.includes(item.VEHICLE_CD));
            //체크리스트set
            setModelList(filterVehicle);
            setVehicleGroupData(result.data[0]);
        }
    }
    const partnerVehicleListAPI = async () => {
        const DATA = { PARTNER_CD: params.cd, ITEM_CD: params.item };
        const result = await axiosPostHandler(`partnerVehicleListByPartnerForAdmin.do`, DATA);
        if (!result || result.message !== "SUCCESS") { setOnMessageHandler(3, '차량을 등록 후 이용해주세요.'); }
        if (result.message === "SUCCESS") {
            const data = result.data.filter(ele => ele.DEL_YN !== "Y");
            if (data.length <= 0) {
                setOnMessageHandler(3, '차량을 등록 후 이용해주세요.');
            } else {
                /* ===== 옵션그룹생성 ===== */
                const newList = data.reduce((prev, now) => {
                    if (!prev.some(obj => obj.value === now.BRAND_KOR_NAME)) {
                        const row = { name: now.BRAND_KOR_NAME, value: now.BRAND_KOR_NAME };
                        prev.push(row)
                    }
                    return prev;
                }, []);
                newList.unshift({ name: '전체', value: '' });
                setVehicleList({ list: data, option: newList });
            }
        }
    }
    return (
        <Element tag={`div`} className={styles.infoContainer}>
            {itemInfo.IMG_SRC === undefined || itemInfo.IMG_SRC === null ?
                <Element tag={`div`} className={styles.imgNoneArea}><Element tag={`span`}>이미지없음</Element></Element>
                : <ImgArea className={["imgArea", styles.imgArea].join(" ")} src={itemInfo.IMG_SRC} alt={itemInfo.ITEM_NAME} />}
            <Element tag={`div`} className={styles.infoArea}>
                <Element tag={`div`}>
                    {priceGroupList && priceGroupList.length > 0 ? priceGroupList.map((item, idx) =>
                        <li key={idx} onClick={(e) => { vehiclePriceListAPI(item) }}>
                            <button>{item.DESCRIPTION + " - " + item.TOT_PRICE}</button>
                        </li>
                    ) : (<></>)}

                    {modelList && modelList.length > 0 ? modelList.map((item, i) =>
                        <>
                            {i == 0 ? <Element tag={`span`}>사용차량</Element> : null}
                            <Element tag={`label`} key={i} className={styles.vehicleList}>{item.BRAND_KOR_NAME + " - " + item.MODEL_KOR_NAME}</Element>
                        </>
                    ) : null}
                </Element>
                {[...Array(10)].map((x, i) =>
                    dataFilter(i, 1) !== undefined && dataFilter(i, 1) !== null ?
                        <Element tag={`div`} key={i}>
                            <Element tag={`span`}>{dataFilter(i, 0)} : </Element><Element tag={`label`}>{dataFilter(i, 1)}</Element>
                        </Element>
                        : null
                )}
            </Element>
        </Element>
    );
}